var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1145.75 128.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:white;}.cls-2{fill:none;}\n        "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\n        Asset 2ldpi\n    ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.42,
    height: 24.88,
    x: 1074.52,
    y: 100.07,
    className: "cls-1",
    transform: "translate(1203.24 -978.22) rotate(90)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1145.75 0.22 1107.25 75.22 1074.79 75.22 1036.29 0.22 1063.04 0.22 1091.88 57.57 1120.71 0.22 1145.75 0.22",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.77,81.74l26.91,47H349.33L323.69,83.94l-11-19.2,16.84,0c.58.06-.6,0,0,0s-.58.06,0,0C341.09,63.87,352,54.18,352,42.4A22.43,22.43,0,0,0,329.53,20h-34V128.35H275.79V.22h59.89a42.32,42.32,0,0,1,11.09,81.52Z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.53,64.77c-.58.06.6,0,0,0s.58.06,0,0Z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 86.5,
    height: 19.75,
    y: 0.22,
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 86.5,
    height: 19.75,
    y: 55.72,
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 86.5,
    height: 19.75,
    y: 109.22,
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 19.75,
    x: 551.67,
    y: 34.85,
    className: "cls-1",
    transform: "translate(640.89 -551.45) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 86.5,
    height: 19.75,
    x: 586.29,
    y: 109.22,
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 58.75,
    height: 19.75,
    x: 194.63,
    y: 19.72,
    className: "cls-1",
    transform: "translate(253.6 -194.4) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.88,75.85l-19.75-.38a32.75,32.75,0,1,1-65.5,0V.22H128.88V75.85a52.5,52.5,0,0,0,105,0Z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.36,0A41.1,41.1,0,0,0,327,.22h8.64A41.1,41.1,0,0,0,331.36,0Z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.75.22a64.07,64.07,0,1,0,64.06,64.06A64.06,64.06,0,0,0,478.75.22Zm0,107.63a43.57,43.57,0,1,1,43.56-43.57A43.57,43.57,0,0,1,478.75,107.85Z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "821.58 88.47 798.91 88.47 777.33 47.8 735.83 128.35 713.17 128.35 777.33 0.22 821.58 88.47",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "830.39 108.02 840.75 128.35 818.08 128.35 807.29 108.02 830.39 108.02",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993,.74v128H973.29V56.25a.84.84,0,0,0-1.44-.59l-40,40.81-64.75-65.1a11.05,11.05,0,0,1-3.2-7.35L863,.22l64.83,66.92,45.46-46.29Z",
    className: "cls-1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e523c77dd56a22495e34ae692349e474.svg";
export { ForwardRef as ReactComponent };